import React, { useState } from 'react';

const StepBullets = ({ currentStep, steps = 1, style }) => {
  const stepsArray = steps === 1 ? [1, 2, 3] : [1, 2];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', ...style }}>
      {stepsArray.map(step => (
        <div
          key={step}
          style={{
            width: currentStep === step ? '12px' : '8px',
            height: currentStep === step ? '12px' : '8px',
            backgroundColor: currentStep === step ? '#2D6DF6' : '#00000042',
            borderRadius: '50%',
            transition: 'all 0.3s ease'
          }}
        />
      ))}
    </div>
  );
};
export default StepBullets;



// WEBPACK FOOTER //
// ./src/containers/client/StepBullets.js